module.exports = "/fonts/fa-solid-900.ttf?1e39699e99c5592e9f70990a735de2a1";